import { useRouter } from 'next/router';
import ChariotConnect from 'react-chariot-connect';
import { PageBySlugQuery } from '~/graphql/page-by-slug';
import { useUtmQuery } from '~/hooks/use-utm-query';
import { PageStatus, PageType } from '~/types/graphql';
import { WORKSPACE_IDS } from '~/config/workspaces';

import { routes } from '~/config/routes';

import { Button } from '~/components/button';

import LockIcon from './assets/lock-icon.svg';
import { ButtonBody, DonateButton, DonateButtonsWrapper } from './style';

type Props = {
  page: PageBySlugQuery['pageBySlug'];
  fundraiser?: PageBySlugQuery['pageBySlug']['fundraisers'][0];
  route: string;
  disabled?: boolean;
};

export const PaymentTypeSelect = ({ page, route, disabled = false }: Props) => {
  const utmQuery = useUtmQuery();
  const router = useRouter();

  const { status, type } = page;
  const closed = status === PageStatus.Closed;
  const isEvent = type === PageType.Event;

  const onDonationRequest = () => {
    return {
      metadata: {
        fundraiserPageName: page.title
      }
    };
  };

  const onSuccess = (e: any) => {
    const detail = e.detail;
    const grantIntent = e.detail.grantIntent;

    const chariotSessionData = {
      workflowSessionId: detail.workflowSessionId,
      userFriendlyId: grantIntent.userFriendlyId,
      fundId: grantIntent.fundId,
      amount: grantIntent.amount
    };

    sessionStorage.setItem('chariotSessionData', JSON.stringify(chariotSessionData));
    router.push(`${route}?chariot=${chariotSessionData.workflowSessionId}`);
  };
  const onExit = () => null;

  return (
    <DonateButtonsWrapper isMobileMarginTop={!page.pageFeatures.donationAmount}>
      <DonateButton
        theme="default"
        size="large"
        href={route}
        query={utmQuery}
        disabled={closed || disabled}
        className={isEvent ? 'w-full !min-w-0' : ''}
      >
        <ButtonBody>
          {page.nonprofit.webId === WORKSPACE_IDS.THE_ADVOCATE ? ( // The Advocate adjustment
            <>{closed ? 'Campaign Has Ended' : 'Join by Credit Card'}</>
          ) : (
            <>
              {!isEvent && <LockIcon />}
              {closed ? 'Campaign Has Ended' : isEvent ? page.ticketButtonLabel : 'Donate with Credit Card'}
            </>
          )}
        </ButtonBody>
      </DonateButton>
      {isEvent && !closed && page.pageFeatures.showDonations && (
        <Button
          variant="outline"
          href={routes.fundraisingPage.checkout(page.slug!).as}
          query={utmQuery}
          disabled={disabled}
          className="w-full !rounded"
        >
          Donate Now
        </Button>
      )}
      {!isEvent && page.pageFeatures.chariotButton ? (
        <ChariotConnect
          cid={page.chariotConnectId!}
          onDonationRequest={onDonationRequest}
          theme="KindestTheme"
          disabled={closed || disabled}
          onSuccess={onSuccess}
          onExit={onExit}
        />
      ) : (
        <></>
      )}
    </DonateButtonsWrapper>
  );
};
